<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="10" :offset="12">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="平台">
                            <el-select v-model="formInline.platformId" placeholder="平台" :disabled="platformDisabled">
                                <el-option v-for="item in platformData"
                                           :key="item.platformId"
                                           :label="item.platformName"
                                           :value="item.platformId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getList()" size="mini" class="header-btn">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="add" size="mini" class="header-btn">新增品牌</el-button>
                        </el-form-item>

                    </el-form>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="品牌id" prop="brand_id"></el-table-column>
            <el-table-column label="品牌名称" prop="brand_wording"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" v-show="scope.row.operateType" @click="edit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" v-show="false" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="新增" :visible.sync="showDialog" center>
            <el-form :model="brand" label-width="80px">
                <!--<el-form-item label="说明">-->
                    <!--<el-alert title="需要上传图片的地方 去菜单 基础管理->图片管理 复制图片路径粘贴过来" type="success" :closable="false">-->
                    <!--</el-alert>-->
                <!--</el-form-item>-->
                <el-form-item label="营业执照或组织机构代码证" :required="true" >
                    <uploadComponents v-model="brand.audit_req.license" :urlType="2"></uploadComponents>
                </el-form-item>
                <el-form-item label="认证审核类型" >
                    <el-select v-model="brand.audit_req.brand_info.brand_audit_type" @change="registerTypeChange" clearable filterable placeholder="认证审核类型">
                        <el-option
                                v-for="item in RegisterTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商标分类" >
                    <el-select v-model="brand.audit_req.brand_info.trademark_type" clearable filterable placeholder="商标分类">
                        <el-option
                                v-for="item in TrademarkTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择品牌经营类型" >
                    <el-select v-model="brand.audit_req.brand_info.brand_management_type" @change="brand_management_typeChange" clearable filterable placeholder="选择品牌经营类型">
                        <el-option
                                v-for="item in BrandManagementTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品产地是否进口" >
                    <el-select v-model="brand.audit_req.brand_info.commodity_origin_type" clearable filterable placeholder="商品产地是否进口">
                        <el-option
                                v-for="item in CommodityOriginTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商标/品牌词" :required="true" >
                    <el-input v-model=brand.audit_req.brand_info.brand_wording clearable placeholder="商标/品牌词" ></el-input>
                </el-form-item>

                <!--<el-form-item v-show="sale_authorizationShow"-->
                        <!--v-for="(domain, index) in brand.audit_req.brand_info.sale_authorization"-->
                        <!--:label="'销售授权书' + index"-->
                        <!--:key="index"-->

                <!--&gt;-->
                    <!--<el-input v-model="domain"></el-input><el-button @click.prevent="removeDomain(index)">删除</el-button>-->
                <!--</el-form-item>-->

                <el-form-item
                        v-for="(domain, index) in domains"
                        :label="'商标注册证书' + (index+1)"
                        :key="domain.key"

                >
                    <uploadComponents v-model="domain.value" :urlType="2"></uploadComponents>
                    <el-button @click.prevent="removeDomain(domain)">删除</el-button>
                </el-form-item>
                <!--<el-form-item-->
                        <!--v-for="(domain, index) in brand.audit_req.brand_info.trademark_change_certificate"-->
                        <!--:label="'商标变更证明' + index"-->
                        <!--:key="index"-->
                <!--&gt;-->
                    <!--<el-input v-model="domain"></el-input><el-button @click.prevent="removeDomain(index)">删除</el-button>-->
                <!--</el-form-item>-->

                <el-form-item label="商标注册人姓名" :required="true" >
                    <el-input v-model=brand.audit_req.brand_info.trademark_registrant clearable placeholder="商标注册人姓名" ></el-input>
                </el-form-item>
                <el-form-item label="商标注册号/申请号" :required="true">
                    <el-input v-model=brand.audit_req.brand_info.trademark_registrant_nu clearable placeholder="商标注册号/申请号 图片url http://***.png" ></el-input>
                </el-form-item>
                <el-form-item label="商标有效期" :required="true"  v-show="trademark_authorization_periodShow">
                    <el-date-picker
                            v-model="brand.audit_req.brand_info.trademark_authorization_period"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="商标有效期">
                    </el-date-picker>
                </el-form-item>
                <!--<el-form-item label="商标注册申请受理通知书" :required="true" v-show="trademark_registration_application_R_Show||trademark_registration_application_T_Show">-->
                    <!--<el-input v-model=brand.audit_req.brand_info.trademark_registration_application clearable placeholder="商标注册申请受理通知书 图片url http://***.png" ></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="商标申请人姓名" :required="true" v-show="trademark_applicant_R_Show||trademark_applicant_T_Show">-->
                    <!--<el-input v-model=brand.audit_req.brand_info.trademark_applicant clearable placeholder="商标申请人姓名" ></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="商标申请时间" :required="true"  v-show="trademark_application_time_R_Show||trademark_application_time_T_Show">-->
                    <!--<el-date-picker-->
                            <!--v-model="brand.audit_req.brand_info.trademark_application_time"-->
                            <!--type="datetime"-->
                            <!--value-format="yyyy-MM-dd HH:mm:ss"-->
                            <!--placeholder="商标申请时间">-->
                    <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="中华人民共和国海关进口货物报关单" v-show="imported_goods_formShow">-->
                    <!--<el-input v-model=brand.audit_req.brand_info.imported_goods_form clearable placeholder="中华人民共和国海关进口货物报关单 图片url http://***.png" ></el-input>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()">确 定</el-button>
                    <el-button @click="addDomain">新增资质材料图片</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="查询审核结果" :visible.sync="categoryResult" center>
            <el-form  label-width="80px">
                <el-form-item label="审核id" :required="true">
                    <el-input v-model=audit_id clearable placeholder="提交audit_id" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="categoryResult = false">取 消</el-button>
                    <el-button type="primary" @click="get_audit_result()">查询</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import uploadComponents from '@/components/upload';
    import {
        audit_Brand,getPlatformList2,get_brand_list,get_audit_category
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    platformId: 4
                },
                categoryResult:false,
                audit_id:0,
                showLicenseStatus:true,
                RegisterTypeList:[{id:1,name:'国内品牌申请-R标'},{id:2,name:'国内品牌申请-TM标'}],
                TrademarkTypeList:[],
                BrandManagementTypeList:[{id:1,name:'自有品牌'},{id:2,name:'代理品牌'},{id:3,name:'无品牌'}],
                CommodityOriginTypeList:[{id:1,name:'是'},{id:2,name:'否'}],
                WxaAuditSourceTypeList:[{id:1,name:'注册'},{id:2,name:'改名'},{id:3,name:'新增品牌'},{id:4,name:'新增类目'},{id:5,name:'新增品牌类目'},{id:6,name:'新增商品'},{id:7,name:'支付审核'}],
                brand:{
                    audit_req:
                    {
                        license: "",
                        brand_info:
                        {
                            brand_audit_type: 1,
                            trademark_type : '29',
                            brand_management_type: 1,
                            commodity_origin_type: 2,
                            brand_wording: '乐纯',
                            sale_authorization: [],
                            trademark_registration_certificate: [],
                            trademark_change_certificate: [],
                            trademark_registrant: '北京乐纯悠品商贸有限公司',
                            trademark_registrant_nu: '1249305',
                            trademark_authorization_period: '',
                            trademark_registration_application: [],
                            trademark_applicant: '北京乐纯悠品商贸有限公司',
                            trademark_application_time: '',
                            imported_goods_form: []
                        }
                    }
                },
                trademark_registration_certificate_R_show:false,
                trademark_registration_certificate_T_show:false,

                trademark_registrant_R_show:false,
                trademark_registrant_T_show:false,

                trademark_registrant_nu_R_show:false,
                trademark_registrant_nu_T_show:false,

                trademark_authorization_period_R_show:false,
                trademark_authorization_period_T_show:false,

                trademark_registration_application_R_show:false,
                trademark_registration_application_T_show:false,

                trademark_applicant_R_show:false,
                trademark_applicant_T_show:false,

                trademark_application_time_R_show:false,
                trademark_application_time_T_show:false,
                list: [],
                domains: [{
                    value: ''
                }]
            }
        },
        created() {

        },
        components:{
            uploadComponents
        },
        //挂载时候执行
        mounted(){
            this.intiTrademarkTypeList();
            this.getPlatfrom();
            this.getList();
        },
        methods: {
            intiTrademarkTypeList(){
                for (let i=1;i<=45;i++)
                {
                    this.TrademarkTypeList.push({id:i+'',name:'第'+i+'类'});
                }
            },
            getList(){
                //查询模板列表
                get_brand_list(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.list = res.data.value;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            add(){
               this.showDialog=true;
            },
            save(){
                this.brand.audit_req.brand_info.trademark_registration_certificate=[];
                for(let j = 0,len=this.domains.length; j < len; j++) {
                    this.brand.audit_req.brand_info.trademark_registration_certificate.push(this.domains[j].value);
                }
                audit_Brand({brand:JSON.stringify(this.brand)}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.value,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            queryCategory(){
                this.categoryResult=true;
                this.showDialog=false;
            },
            uploadCategory(){
                this.categoryResult=false;
                this.showDialog=true;
            },
            get_audit_result(){
                get_audit_category({platformId:this.formInline.platformId,audit_id:this.audit_id}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.value,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getPlatfrom(){
                //初始化首页数据
                getPlatformList2().then((res) => {
                    this.platformData = res.data;
                });
            },
            registerTypeChange(registerType){
                this.intiShow();
                if(registerType==1){
                    //R标
                    this.trademark_registration_certificate_R_show=true;
                    this.trademark_registrant_R_show=true;
                    this.trademark_registrant_nu_R_show=true;
                    this.trademark_authorization_period_R_show=true;
                    this.trademark_registration_application_R_show=true;
                    this.trademark_applicant_R_show=true;
                    this.trademark_application_time_R_show=true;
                }else if(registerType==2){
                    //tm 标
                    this.trademark_registration_certificate_T_show=false;
                    this.trademark_registrant_T_show=false;
                    this.trademark_registrant_nu_T_show=false;
                    this.trademark_authorization_period_T_show=false;
                    this.trademark_registration_application_T_show=false;
                    this.trademark_applicant_T_show=false;
                    this.trademark_application_time_T_show=false;
                }
            },
            brand_management_typeChange(brand_management_type){
                this.intiShow();

                if(brand_management_type==1){
                    //自有
                    this.trademark_registration_certificate_S_show=true;
                    this.trademark_registrant_S_show=true;
                    this.trademark_registrant_nu_S_show=true;
                    this.trademark_authorization_period_S_show=true;
                    this.trademark_registration_application_S_show=true;
                    this.trademark_applicant_S_show=true;
                    this.trademark_application_time_S_show=true;
                }else if(brand_management_type==2){
                    //代理
                    this.trademark_registration_certificate_A_show=true;
                    this.trademark_registrant_A_show=true;
                    this.trademark_registrant_nu_A_show=true;
                    this.trademark_authorization_period_A_show=true;
                    this.trademark_registration_application_A_show=true;
                    this.trademark_applicant_A_show=true;
                    this.trademark_application_time_A_show=true;
                }
            },
            intiShow(){
                this.trademark_registration_certificate_R_show=false;
                this.trademark_registration_certificate_T_show=false;

                this.trademark_registrant_R_show=false;
                this.trademark_registrant_T_show=false;

                this.trademark_registrant_nu_R_show=false;
                this.trademark_registrant_nu_T_show=false;

                this.trademark_authorization_period_R_show=false;
                this.trademark_authorization_period_T_show=false;

                this.trademark_registration_application_R_show=false;
                this.trademark_registration_application_T_show=false;

                this.trademark_applicant_R_show=false;
                this.trademark_applicant_T_show=false;

                this.trademark_application_time_R_show=false;
                this.trademark_application_time_T_show=false;

                this.trademark_registration_certificate_S_show=true;
                this.trademark_registration_certificate_A_show=false;

                this.trademark_registrant_S_show=true;
                this.trademark_registrant_A_show=false;

                this.trademark_registrant_nu_S_show=false;
                this.trademark_registrant_nu_A_show=false;

                this.trademark_authorization_period_S_show=false;
                this.trademark_authorization_period_A_show=false;

                this.trademark_registration_application_S_show=false;
                this.trademark_registration_application_A_show=false;

                this.trademark_applicant_S_show=false;
                this.trademark_applicant_A_show=false;

                this.trademark_application_time_S_show=false;
                this.trademark_application_time_A_show=false;
            },
            removeDomain(item) {
                var index = this.domains.indexOf(item)
                if (index !== -1) {
                    this.domains.splice(index, 1)
                }
            },
            addDomain() {
                this.domains.push({
                    value: '',
                    key: Date.now()
                });
            },
            add_trademark_registration_certificate() {
                this.brand.audit_req.brand_info.trademark_registration_certificate.push('');
            },
            remove_trademark_change_certificate(item) {
                if (index !== -1) {
                    this.brand.audit_req.brand_info.trademark_change_certificate.splice(index, 1)
                }
            },
            add_trademark_change_certificate() {
                this.brand.audit_req.brand_info.trademark_change_certificate.push('');
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/minishop/brand.vue